import currentStage from "../stages.const";

const ENDPOINTS = {
    // "ALPHA": "https://api.beta.bookmarks.opstechit.amazon.dev",
    "ALPHA": "https://api.alpha.bookmarks.opstechit.amazon.dev",
    "BETA": "https://api.beta.bookmarks.opstechit.amazon.dev",
    "PROD": "https://api.bookmarks.opstechit.amazon.dev"
}

export const baseUrl = ENDPOINTS[currentStage];
